const smtPqSectionTitle = {
    color: {
        default: 'brand.500',
        _dark: 'brand.600',
    },
};

export default smtPqSectionTitle;